import { ProfileCard } from '@/components/common/ProfileCard';
import { useSectors } from '@/features/startups/hooks/useSectors';
import { PROFILE_LAYOUT_STRINGS as L } from '@/lib/constants/profile-layout-strings';
import { INVESTOR_CARD_STRINGS as C } from './investor-form.constants';
import type { InvestorCardProps } from './InvestorPreferenceCards';

/**
 * Colleague contacts by industry (MYN-202, FR-175) as a profile card
 * (MYN-217): one tile per colleague - the sector, their name and email -
 * three to a row. Contact-only: no account is created and no email is sent.
 */
export function InvestorColleaguesCard({ data, action, onAdd }: InvestorCardProps) {
  const { data: sectors = [] } = useSectors();
  const contacts = data.colleagueContacts ?? [];
  return (
    <ProfileCard title={C.COLLEAGUES} action={action}>
      {contacts.length === 0 ? (
        <p className="text-input text-subtext">{onAdd ? C.COLLEAGUES_EMPTY : L.NOT_PROVIDED}</p>
      ) : (
        <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3">
          {contacts.map((contact) => (
            // Not `contact.id`: the Backend regenerates row ids on every save;
            // one colleague per sector, so the sector id is a stable key.
            <li
              key={contact.sectorId}
              className="bg-page-bg min-w-0 rounded-[0.875rem] px-4 py-3.5"
            >
              <p className="text-subtext text-xs">
                {sectors.find((sector) => sector.id === contact.sectorId)?.name ?? L.EMPTY_STAT}
              </p>
              <p className="text-navy truncate text-sm font-medium">{contact.name}</p>
              <p className="text-subtext truncate text-[0.8125rem]" title={contact.email}>
                {contact.email}
              </p>
            </li>
          ))}
        </ul>
      )}
    </ProfileCard>
  );
}
